import postawaImage from "../../assets/POSTAWA.png";
import mowaImage from "../../assets/MOWA.png";
import gestImage from "../../assets/GEST.png";
import chodImage from "../../assets/CHOD.png";
import greenred from "../../assets/green-red.png";
import greenblue from "../../assets/green-blue.png";
import greengreen from "../../assets/green-green.png";
import greenyellow from "../../assets/green-yellow.png";
import t, { tImage } from "../../translations";

export default [
  {
    title: t("green_section_one_title"),
    subSections: [
      {
        title: t("green_subsection_one_title"),
        description: [
          t("green_subsection_one_description_one"),
          t("green_subsection_one_description_two"),
          t("green_subsection_one_description_three"),
          t("green_subsection_one_description_four"),
          t("green_subsection_one_description_five"),
          ,
          t("green_subsection_one_description_six"),
          t("green_subsection_one_description_seven"),
          t("green_subsection_one_description_eight"),
          t("green_subsection_one_description_nine"),
          t("green_subsection_one_description_ten"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("green_chart", props) },
      {
        title: t("green_subsection_two_title"),
        description: [
          t("green_subsection_two_description_one"),
          t("green_subsection_two_description_two"),
        ],
        positionText: "right",
      },
      {
        title: t("green_subsection_three_title"),
        description: [t("green_subsection_three_description_one")],
        positionText: "right",
      },
    ],
  },
  {
    title: t("green_section_two_title"),
    subSections: [
      {
        title: t("green_subsection_two_one_title"),
        description: [
          t("green_subsection_two_one_description_one"),
          t("green_subsection_two_one_description_two"),
        ],
        image: postawaImage,
        positionText: "right",
      },
      {
        title: t("green_subsection_two_two_title"),
        description: [
          t("green_subsection_two_two_description_one"),
          t("green_subsection_two_two_description_two"),
          t("green_subsection_two_two_description_three"),
        ],
        image: chodImage,
      },
      {
        title: t("green_subsection_two_three_title"),
        description: [
          t("green_subsection_two_three_description_one"),
          t("green_subsection_two_three_description_two"),
          t("green_subsection_two_three_description_three"),
        ],
        image: gestImage,
        positionText: "right",
      },
      {
        title: t("green_subsection_two_four_title"),
        description: [
          t("green_subsection_two_four_description_one"),
          t("green_subsection_two_four_description_two"),
          t("green_subsection_two_four_description_three"),
          t("green_subsection_two_four_description_four"),
          t("green_subsection_two_four_description_five"),
        ],
        image: mowaImage,
      },
    ],
  },
  {
    title: t("green_section_three_title"),
    subSections: [
      {
        title: t("green_subsection_three_one_title"),
        description: [
          t("green_subsection_three_one_description_one"),
          t("green_subsection_three_one_description_two"),
          t("green_subsection_three_one_description_three"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("greenInStress_chart", props) },
      {
        title: t("green_subsection_three_two_title"),
        description: [
          t("green_subsection_three_two_description_one"),
          t("green_subsection_three_two_description_two"),
        ],
        positionText: "right",
      },
      {
        title: t("green_subsection_three_three_title"),
        description: [
          t("green_subsection_three_three_description_one"),
          t("green_subsection_three_three_description_two"),
        ],
        positionText: "right",
      },
    ],
  },
  {
    title: t("green_section_four_title"),
    subSections: [
      {
        description1: t("green_subsection_four_one_description1_one"),
        description2: t("green_subsection_four_one_description2_two"),
      },
      { image: (props) => tImage("team_image", props) },
    ],
  },
  {
    title: t("green_section_five_title"),
    subSections: [
      {
        title: t("green_subsection_five_one_title"),
        description: t("green_subsection_five_one_description_one"),
        isOneAboveAnother: true,
      },
      {
        title: t("green_subsection_five_two_title"),
        description: [
          t("green_subsection_five_two_description_one"),
          t("green_subsection_five_two_description_two"),
          t("green_subsection_five_two_description_three"),
          t("green_subsection_five_two_description_four"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("communication_image", props) },
      {
        title: t("green_subsection_five_three_title"),
        description: [
          t("green_subsection_five_three_description_one"),
          t("green_subsection_five_three_description_two"),
          t("green_subsection_five_three_description_three"),
          t("green_subsection_five_three_description_four"),
        ],
      },
    ],
  },
  {
    title: t("green_section_six_title"),
    subSections: [
      {
        title: t("green_subsection_six_one_title"),
        description: true,
      },
      {
        title: t("green_subsection_six_two_title"),
        description: [
          t("green_subsection_six_two_description_one"),
          t("green_subsection_six_two_description_two"),
          t("green_subsection_six_two_description_three"),
          t("green_subsection_six_two_description_four"),
          t("green_subsection_six_two_description_five"),
          t("green_subsection_six_two_description_six"),
          t("green_subsection_six_two_description_seven"),
          t("green_subsection_six_two_description_eight"),
        ],
        image: greenred,
        positionText: "right",
      },
      {
        title: t("green_subsection_six_three_title"),
        description: [
          t("green_subsection_six_three_description_one"),
          t("green_subsection_six_three_description_two"),
          t("green_subsection_six_three_description_three"),
          t("green_subsection_six_three_description_four"),
          t("green_subsection_six_three_description_five"),
          t("green_subsection_six_three_description_six"),
        ],
        image: greenyellow,
        positionText: "right",
      },
      {
        title: t("green_subsection_six_four_title"),
        description: [
          t("green_subsection_six_four_description_one"),
          t("green_subsection_six_four_description_two"),
          t("green_subsection_six_four_description_three"),
          t("green_subsection_six_four_description_four"),
          t("green_subsection_six_four_description_five"),
          t("green_subsection_six_four_description_six"),
          t("green_subsection_six_four_description_seven"),
          t("green_subsection_six_four_description_eight"),
        ],
        image: greenblue,
        positionText: "right",
      },
      {
        title: t("green_subsection_six_five_title"),
        description: [
          t("green_subsection_six_five_description_one"),
          t("green_subsection_six_five_description_two"),
          ,
          t("green_subsection_six_five_description_three"),
          t("green_subsection_six_five_description_four"),
        ],
        image: greengreen,
        positionText: "right",
      },
    ],
  },
];
